export const ROOT_ELEMENT_SELECTOR = '#dashboard-main';
